import React, { useEffect, useState,  } from 'react'
import { Modal, Steps, Form, Space, App} from 'antd'        
import Icon from '../../../cpn/Icon';
import UserSelect from '../../user/UserSelect';
import { useTDspjdPLAddMutation, useTDspjdListQuery } from '../../../store/DianShangYeWuApi';
function ReportNodeCopyAdd(props) {    
    const { message } = App.useApp();
    const [open, setOpen] = useState(false);
    const [submitAdd] = useTDspjdPLAddMutation()    
    const {data, isSuccess} = useTDspjdListQuery({dsbzd_spjd_qy_id:props.qy_id,dsbzd_spjd_user_id:props.dsbzd_spjd_user_id},{skip:!open});
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const newArr = data.Result.map(item => {
                    const {dsbzd_spjd_id:key,dsbzd_spjd_name,dsbzd_spjd_yh_name,dsbzd_spjd_xuhao,dsbzd_spjd_yh_id} = item;
                    return {
                        key,
                        title: dsbzd_spjd_name + '：' + dsbzd_spjd_yh_name,
                        content: '',
                        dsbzd_spjd_xuhao: dsbzd_spjd_xuhao,
                        dsbzd_spjd_yh_id: dsbzd_spjd_yh_id,
                        dsbzd_spjd_yh_name: dsbzd_spjd_yh_name,
                        dsbzd_spjd_name: dsbzd_spjd_name,
                        status: 'wait',
                    }
                })
                const sortArr = newArr.sort( (a, b) => {
                    return a.dsbzd_spjd_xuhao - b.dsbzd_spjd_xuhao;
                })                    
                setItems(sortArr);
                
            } else {
                setItems([]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.user_name])    
    // eslint-disable-next-line no-unused-vars
    const [user, setUser] = useState({dsbzd_spjd_user_id:'',dsbzd_spjd_user_name:''});
    const onAdd = () => {
        if(!user.dsbzd_spjd_user_id || !user.dsbzd_spjd_user_name){
            message.error("请先选择团队报账单操作员");
            return;
        }
        let obj ={
            'dsbzd_spjd_qy_id': props.qy_id,
            'dsbzd_spjd_qy_name': props.qy_name,
            'dsbzd_spjd_xuhao': '',
            'dsbzd_spjd_name': '',
            'dsbzd_spjd_yh_id': '',
            'dsbzd_spjd_yh_name': '',
            'dsbzd_spjd_uid': props.yh_id,
            'dsbzd_spjd_uname': props.yh_name,
            'dsbzd_spjd_content': '',
            'dsbzd_spjd_user_id': user.dsbzd_spjd_user_id,
            'dsbzd_spjd_user_name': user.dsbzd_spjd_user_name,
        }
        // 1. 校验填单人
        if (!user.dsbzd_spjd_user_id || !user.dsbzd_spjd_user_name) {
            message.error("请先选择团队报账单操作员");
            return;
        }
        // 2. 校验 items 节点
        if (!items || items.length === 0 || (items.length === 1 && !items[0].dsbzd_spjd_yh_id)) {
            message.error("请设置至少一个审批/抄送节点");
            return;
        }
        // 3. 过滤掉无效节点
        const validItems = items.filter(item => !!item.dsbzd_spjd_yh_id && !!item.dsbzd_spjd_yh_name);

        // 4. 填充 obj 字段
        // 不需要前面1,2两个元素了，直接从items的第一个开始
        // 填充序号
        let s = validItems.length;
        let xuhaoArr = [];
        for(let i=1; i<=s; ++i) xuhaoArr.push(i);
        obj.dsbzd_spjd_xuhao = xuhaoArr.join(',');

        // 填充dsbzd_spjd_name
        obj.dsbzd_spjd_name = validItems.map(item => item.dsbzd_spjd_name).join(',');

        // 填充dsbzd_spjd_yh_id
        obj.dsbzd_spjd_yh_id = validItems.map(item => item.dsbzd_spjd_yh_id).join(',');

        // 填充dsbzd_spjd_yh_name
        obj.dsbzd_spjd_yh_name = validItems.map(item => item.dsbzd_spjd_yh_name).join(',');

        // 填充dsbzd_spjd_content
        obj.dsbzd_spjd_content = validItems.map(item => item.content || '').join(',');

        // 5. 提交
        submitAdd(obj).then(res => {
            if (res && res.data && res.data.Status === 'success') {
                message.success('复制新增成功');
                setOpen(false);
                setItems([]);
                setUser({dsbzd_spjd_user_id:'',dsbzd_spjd_user_name:''});
                props.onSuccess && props.onSuccess();
            } else {
                message.error('复制新增失败：' + (res?.data?.Message || '未知错误'));
            }
        });
    }
    return (
        <>
            <Icon 
                type='copy' 
                onClick={() => {
                    setOpen(true);
                    
                }}  
            title='复制新增'
        />
            <Modal
                open={open}
                onCancel={() => {
                    setOpen(false);
                    setUser({dsbzd_spjd_user_id:'',dsbzd_spjd_user_name:''});
                }}
                onOk={() => {}}
                footer={null}
                title='复制新增'
            >
                <Form 
                    form={form} 
                    layout='horizontal' 
                    labelCol={{ span: 8 }}
                    name={`form_${props.dsbzd_spjd_user_id}`}
                >
                   
                    <Form.Item label="团队报账单审批点">                        
                        <div>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>
                    <UserSelect
                        qy_id={props.qy_id}
                        onChange={(value) => {
                            setUser({dsbzd_spjd_user_id:value.yh_id,dsbzd_spjd_user_name:value.yh_name});
                        }}
                        label="复制给操作员"
                        name="dsbzd_spjd_user_id"
                        required
                        wrapperCol={{ span: 12 }}
                        placeholder="请选择操作员"
                    /> 
                    <Form.Item wrapperCol={{ offset: 8,}}>
                        <Space size={30}>                            
                            <Icon 
                                type='save' 
                                onClick={onAdd} 
                                title='保存' 
                                key='save'
                            />                            
                        </Space>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}
export default ReportNodeCopyAdd